/* @flow */
import Flickity from 'flickity';
import {selectAll} from '../utilities/select';
import type {Module} from '../types';

let instances: Array<Flickity> = [];

const gallery: Module & {
  resizeAll: () => void
} = {
  init(): void {
    this.destroy();

    selectAll('.js-image-gallery').forEach((el: HTMLElement) => {
      instances.push(new Flickity(el, {
        cellSelector: '.c-image-block--gallery__entry'
      }));
    });
  },
  resizeAll(): void {
    instances.forEach((instance: Flickity) => {
      instance.resize();
    });
  },
  destroy(): void {
    instances.forEach((instance: Flickity) => {
      instance.destroy();
    });
    instances = [];
  }
};

export default gallery;



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/magazine/gallery.js